<template>
  <div class="_wrapper">

    <!-- Add to cart -->
    <mini-add-to-cart v-if="isCheckoutAllowed && activeButtonAddToCart" class="add-to-cart" :product="product" />
    <!---->

    <router-link :to="productLink" class="search-item no-underline">

      <!-- Product image -->
      <div class="search-item-image">
        <product-image-slider class="search-item-image-content"
                              :image="thumbnailObj"
                              :key="product.sku"
                              :alt="product.name | htmlDecode"
                              data-testid="productImage"
                              v-if="currentPartner && currentPartner.hasOwnProperty('display_mode')
                                  && currentPartner.display_mode === 'shop'"
        />
        <product-image :image="thumbnailObj"
                       :key="product.sku"
                       :alt="product.name | htmlDecode"
                       data-testid="productImage"
                       v-else
        />
      </div>
      <!---->

      <!-- Article -->
      <div class="search-item-article">

        <!-- Details -->
        <div class="search-item-article-about">
          <h1 class="search-item-article-about-title"> {{ product.name | htmlDecode }} </h1>
          <h3 class="search-item-article-about-subtitle" v-if="product.weight"> {{ $t('Weight') }}: {{ product.weight }} </h3>
        </div>
        <!---->

        <!-- Main price -->
        <div class="search-item-article-details">
          <div class="search-item-article-details-price">
        <span class="search-item-article-details-price-text"
              v-if="!product.special_price
                      || product.price === product.originalPriceInclTax
                      && parseFloat(product.price) > 0
                      && !onlyImage"
        > {{ product.price | price }} </span>
            <span class="search-item-article-details-price-text"
                  v-if="product.special_price
                  && product.price !== product.originalPriceInclTax
                  && parseFloat(product.originalPriceInclTax) > 0
                  && !onlyImage"
            > <del> {{ product.originalPriceInclTax | price }} </del> </span>
            <span class="search-item-article-details-price-discount"
                  v-if="product.special_price
                  && product.price !== product.originalPriceInclTax
                  && parseFloat(product.special_price) > 0
                  && !onlyImage"
            > {{ product.price | price }} </span>
          </div>
        </div>
        <!---->

      </div>
      <!---->

    </router-link>
  </div>
</template>

<script>
import ProductImageSlider from 'theme/components/core/ProductImageSlider'
import { ProductTile } from '@vue-storefront/core/modules/catalog/components/ProductTile'
import ProductImage from 'theme/components/core/ProductImage'
import MiniAddToCart from 'theme/components/core/blocks/Shop/Product/MiniAddToCart'
import { mapGetters } from 'vuex'

export default {
  mixins: [ProductTile],
  components: {
    ProductImage,
    MiniAddToCart,
    ProductImageSlider
  },
  props: {
    labelsActive: {
      type: Boolean,
      default: true
    },
    onlyImage: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isActiveDesc: false,
      flagDescriptions: false,
      singleOptionProduct: null
    }
  },
  beforeMount () {
    this.$bus.$on('product-after-priceupdate', this.onProductPriceUpdate)
  },
  mounted () {
    if (this.$refs.descriptions !== undefined) {
      this.flagDescriptions = this.$refs.descriptions.offsetHeight >= 170
    }
    this.$bus.$on('product-after-customoptions', this.onAfterCustomOptionsChanged)
    if (this.product.custom_options && this.product.custom_options.length === 1 && this.product.custom_options.filter(option => option.is_active === 1).length) {
      this.singleOptionProduct = this.product
      this.setupInputFields()
    }
  },
  computed: {
    ...mapGetters({
      currentLocation: 'locations/getActiveLocation',
      currentPartner: 'partners/getCurrentPartner'
    }),
    thumbnailObj () {
      return {
        src: this.thumbnail,
        loading: this.placeholder
      }
    },
    activeButtonAddToCart () {
      return this.currentPartner.active && this.currentPartner.enabled
    },
    isCheckoutAllowed () {
      return (this.currentLocation.hasOwnProperty('is_checkout_allowed')) ? this.currentLocation.is_checkout_allowed : true
    }
  },
  methods: {
    redirectToProduct () {
      this.$router.push(this.productLink)
    }
  }
}
</script>

<style lang="scss" scoped>
._wrapper {
  position: relative;

  &:hover {
    & .search-item-image-content {
      transform: scale(.9);
    }
  }
}

.add-to-cart {
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
}

.search-item {
  width: 100%;
  padding: 10px 0;

  display: flex;
  align-items: center;

  border-bottom: 1px solid #efeff4;

  & + & {
    margin-top: 10px;
  }

  &-image {
    width: 75px;
    height: 75px;
    margin-right: 10px;
    min-width: 75px;

    &-content {
      width: 100%;
      height: 100%;

      display: flex;
      justify-content: center;
      align-items: center;

      transition: .2s;
    }
  }

  &-article {
    display: flex;
    align-items: center;

    @media only screen and (max-width: 991px) {
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
    }

    &-about {
      width: 270px;

      display: flex;
      flex-direction: column;

      @media only screen and (max-width: 1200px) {
        width: 220px;
      }

      @media only screen and (max-width: 991px) {
        width: 130px;
      }

      @media only screen and (max-width: 576px) {
        width: auto;
        min-width: 100px;
      }

      &-title, &-subtitle {
        margin: 0;
      }

      &-title {
        color: #0f0f0f;
        font-size: 14px;
        font-weight: 300;
        line-height: 20px;
      }

      &-subtitle {
        color: #111;
        font-size: 14px;
        font-weight: 100;

        opacity: .5;
      }
    }

    &-details {
      margin-left: 20px;

      display: flex;
      align-items: center;

      @media only screen and (max-width: 991px) {
        margin-top: 20px;
        margin-left: 0;
      }

      &-price {
        display: inline-grid;
        @media (max-width: 992px) {
          display: flex;
        }

        &-text, &-discount {
          font-size: 14px;
          font-weight: 600;
        }

        &-text {
          color: #0f0f0f;

          & del {
            color: #757575;
          }
        }

        &-discount {
          margin-top: 5px;
          color: #ea2200;
          @media (max-width: 992px) {
            margin-left: 6px;
            margin-top: 0;
          }
        }
      }
    }
  }
}
</style>
